import {
  LOCATIONVEHICLE_FETCHING,
  LOCATIONVEHICLE_FAILED,
  LOCATIONVEHICLE_SUCCESS,
} from "./types";
import SiteService from "../services/site.service";

export const getLocationAndVehicleUsage =
  (idDriver) => async (dispatch) => {
    try {
      dispatch({
        type: LOCATIONVEHICLE_FETCHING,
      });
      const res = await SiteService.getLocationAndVehicleUsage(
        idDriver
      );
      if (res) {
        dispatch({
          type: LOCATIONVEHICLE_SUCCESS,
          payload: res.data,
        });
      }
    } catch (err) {
      dispatch({
        type: LOCATIONVEHICLE_FAILED,
      });
      console.log(err);
    }
  };

// import {
//   DELIVERYSAMPLEGPS_FETCHING,
//   DELIVERYSAMPLEGPS_FAILED,
//   DELIVERYSAMPLEGPS_SUCCESS,
// } from "./types";
// import SiteService from "../services/site.service";

// export const getLocationAndVehicleUsage =
//   (idDriver) => async (dispatch) => {
//     try {
//       dispatch({
//         type: DELIVERYSAMPLEGPS_FETCHING,
//       });
//       const res = await SiteService.getLocationAndVehicleUsage(
//         idDriver
//       );
//       if (res) {
//         dispatch({
//           type: DELIVERYSAMPLEGPS_SUCCESS,
//           payload: res.data,
//         });
//       }
//     } catch (err) {
//       dispatch({
//         type: DELIVERYSAMPLEGPS_FAILED,
//       });
//       console.log(err);
//     }
//   };
